import { render, staticRenderFns } from "./ProductsGallery.vue?vue&type=template&id=4c348f5b&scoped=true&"
import script from "./ProductsGallery.vue?vue&type=script&lang=js&"
export * from "./ProductsGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProductsGallery.vue?vue&type=style&index=0&id=4c348f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c348f5b",
  null
  
)

export default component.exports